export default class StickyTriggers {
  constructor(container) {
    this.$container = container;

    this.header = document.querySelector('[data-faceted-search-header]');
    this.sort = document.querySelector(
      '[data-faceted-search-pagination-sort-clear]',
    );

    this.cssClasses = {
      stickySort: 'faceted-search-pagination-sort-clear--sticky',
      stickyTriggers: 'faceted-search-sticky-triggers--sticky',
    };

    this.observer = new IntersectionObserver(
      (entry) => {
        const element = entry[0];

        // If the header is going out of view, make trigger container sticky
        if (element.intersectionRatio < 0.5) {
          this.$container.classList.add(this.cssClasses.stickyTriggers);
          this.sort.classList.add(this.cssClasses.stickySort);
        } else {
          this.$container.classList.remove(this.cssClasses.stickyTriggers);
          this.sort.classList.remove(this.cssClasses.stickySort);
        }
      },
      {
        threshold: [0.1, 0.5, 0.9, 1],
      },
    );
  }

  events() {
    this.observer.observe(this.header);
  }
}
